import Swiper from './swiper-setup';
import { findAndReplace as ytReplace, pauseVideo } from './../youtube/youtube-utils';
import $ from 'jquery';

function onSlideChangeEnd(swiper) {
  const $previous = $(swiper.slides[swiper.previousIndex]);
  if ($previous.hasClass('js-gallery-dialog-slide--video')) {
    pauseVideo($previous);
  }
}

function init(slug, index = 0) {

  let swiper;

  const dialogTemplate = `
    <aside class="l-dialog l-dialog--gallery" role="dialog">
      <div class="l-dialog-container-main js-l-dialog-container-main">
        <button type="button" class="l-dialog-close js-l-dialog-dismissal-item"></button>
        <div class="l-dialog-content-target js-l-dialog-content-target"></div>
      </div>
    </aside>`;

  lDialog.open({
    template: dialogTemplate,
    ajax: {
      url: '/h/gallery/ShowDialogGallery',
      content: '&nbsp;',
      data: { slug },
      complete: () => {
        ytReplace();
        swiper = new Swiper('#gallery-dialog-slideshow', {
          slideClass: 'js-gallery-dialog-slide',
          wrapperClass: 'ss__slides',
          prevButton: '.ss__btn-page--prev',
          nextButton: '.ss__btn-page--next',
          initialSlide: index,
          onSlideChangeEnd
        });
      },
      beforeClose: () => {
        swiper.destroy();
      }
    }
  });

}

function registerLaunchers() {
  $('.js-gallery-dialog-launcher').on('click', e => {
    const $el = $(e.currentTarget);
    const slug = $el.attr('data-gallery-slug');
    const index = parseInt($el.attr('data-gallery-slide-index') || 0, 10);
    init(slug, index);
  });
}

$(registerLaunchers);

export { registerLaunchers };